// "Download packet" (PORTAL-PACKET-2026-10-09 §6) in the staff member's browser: the data (logged), the blank forms
// (public/forms/), the uploads through 60-second signed links, pdf-lib loaded only now. Nothing is stored anywhere.
import { buildPacket, packetModel, PACKET_UPLOADS, FORMS, SCRIPT_FONT_FILE } from './packet';

export const UPLOAD_LABELS = {
  voided_check: 'Voided check or bank letter', gov_id_front: 'Government ID (front)', gov_id_back: 'Government ID (back)', i20: 'Form I-20',
};

async function defaultFetchBytes(url) {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`Could not fetch a packet file (HTTP ${r.status})`);
  return new Uint8Array(await r.arrayBuffer());
}

/** -> { bytes, pages, skipped, filename }. only = a form key for one filled form alone. */
export async function makePacket({ api, candidate, by, only = null, loadPdfLib = () => import('pdf-lib'), fetchBytes = defaultFetchBytes,
  loadFontkit = () => import('@pdf-lib/fontkit') }) {
  const raw = await api.packetData(candidate, by, only);   // a one-form download is logged as such (§4)
  const model = packetModel(raw);
  const PDFLib = await loadPdfLib();
  const uploads = [];
  if (!only || only === 'i9') {                      // the I-9 alone carries its ID photos too
    for (const kind of only ? ['gov_id_front', 'gov_id_back'] : PACKET_UPLOADS) {
      const doc = (raw.documents || []).find((d) => d.kind === kind);   // newest first
      if (!doc) continue;
      uploads.push({ kind, label: UPLOAD_LABELS[kind], bytes: await fetchBytes(await api.signedUrl(doc.storage_path)) });
    }
  }
  // PORTAL-ESIGN-PROOF-2026-10-12 §5: signatures in Dancing Script (subset-embedded); without it, the packet still builds
  let script = null;
  try {
    const fk = await loadFontkit();
    script = { fontkit: fk.default || fk, bytes: await fetchBytes(`/fonts/${SCRIPT_FONT_FILE}`) };
  } catch (e) { script = null; }
  const out = await buildPacket(PDFLib, { fetchForm: (file) => fetchBytes(`/forms/${file}`), model, uploads, only, script });
  const what = only ? FORMS.find((f) => f.key === only).file.replace(/\.pdf$/, '') : 'packet';
  return { ...out, cursive: !!script, filename: `onboarding-${what}-${candidate.id}.pdf` };
}

export function saveBytes(bytes, filename) {
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
